export const hotjarSiteId = 3351579;

export const hotjarVersion = 6;
